import { useContext } from "react";
import CircuitBreakerSVG from "../SLD/CircuitBreakerSVG";
import PowerMeterSVG from "../SLD/PowerMeterSVG";
import PvSLD from "../SLD/PvSLD";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
import DummyCB from "../SLD/DummyCB";
const PV = ({id,x,y,px,cx,pvX, selectHandler,index}) =>{
  const {
    CBAssetList,
  } = useContext(DesignAssetContext);
  const isPMRequired = CBAssetList[index]?.uiData?.pmRequired || false; 
  const isCBRequired = CBAssetList[index]?.uiData?.cbRequired || false;
    return (
    <svg x ={pvX} y="2" className="pointer">
        <PvSLD id ={id} x={x} y = {y} index ={index} selectHandler={selectHandler} />
       { isPMRequired && <PowerMeterSVG
              id = {"_PV"}
              x={px}
              y="127.5"
              index ={index}
            />}
          { isCBRequired? <CircuitBreakerSVG
              id={"_PV"}
               x ={cx}
              y ={"266"}
              index ={index}
               cbRequiredSelection = {true}
                name={CBAssetList[index]?.cbConfigData?.name || ""}
            />:
            <DummyCB   x ={Number(cx) + 35.5} y ={"266"}/>
          
          }
    </svg>);
}
export default PV;